'use client'

import { Button, html } from '@ensemble.music/ui'
import { CONTACT_EMAIL, finalCta } from './content'

export function FinalCta({ onStart }: { onStart: () => void }) {
  return (
    <html.section className="landing-final flex flex-row justify-center bg-primary-soft">
      <html.div className="flex flex-col items-center gap-5 w-full max-w-[1120px] mx-auto px-8 py-20 text-center max-sm:px-4 max-sm:py-14">
        {/* The closing headline matches the hero in weight, not the section heads: it is the end
            of the page, not another section. */}
        <html.h2 className="max-w-[720px] text-4xl font-semibold leading-tight tracking-tight text-color max-md:text-3xl max-sm:text-2xl">
          {finalCta.headline}
        </html.h2>
        <html.p className="max-w-[560px] text-lg text-color-secondary">{finalCta.body}</html.p>
        <Button
          type="button"
          size="lg"
          onClick={onStart}
        >
          {finalCta.button}
        </Button>
        <html.p className="text-base text-color-secondary">
          Lieber erst eine Frage? Schreib uns:{' '}
          <html.a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-link hover:underline"
          >
            {CONTACT_EMAIL}
          </html.a>
        </html.p>
      </html.div>
    </html.section>
  )
}
